var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramMobile40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.309804 0 0 0 0 0.298039 0 0 0 0 0.301961 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    points: "13.097819 8.43033854 26.9122721 8.43033854 27.5 26 12.5 26"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFCC00",
    points: "12.5 25 27.5 25 26.7272949 31.7220459 13.1610107 31.5065918"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.500000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,17.2675781 L15,3 C15,1.34314575 13.6568542,-3.04359188e-16 12,0 L3,0 C1.34314575,3.04359188e-16 -2.02906125e-16,1.34314575 0,3 L0,21 C2.02906125e-16,22.6568542 1.34314575,24 3,24 L12,24 C13.6568542,24 15,22.6568542 15,21 L15,17.1958705 L15,17.1958705 L0.349469866,17.1958705",
    id: "Path-2",
    stroke: "#979797"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#979797",
    fill: "#D8D8D8",
    cx: 7.5,
    cy: 21,
    r: 1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramMobile40);
export default __webpack_public_path__ + "static/media/pictogramMobile40.0ea61312721900f437fc275b93cdc87c.svg";
export { ForwardRef as ReactComponent };